import { render, staticRenderFns } from "./Aniversariantes.vue?vue&type=template&id=5ba1b93a&scoped=true"
import script from "./Aniversariantes.vue?vue&type=script&lang=js"
export * from "./Aniversariantes.vue?vue&type=script&lang=js"
import style0 from "./Aniversariantes.vue?vue&type=style&index=0&id=5ba1b93a&prod&scoped=true&lang=css"
import style1 from "./Aniversariantes.vue?vue&type=style&index=1&id=5ba1b93a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1b93a",
  null
  
)

export default component.exports